import Vue from 'vue'
import debounce from 'lodash/debounce'
Vue.prototype.$debounce = debounce
